import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import zenputIcon from "assets/svg/logo_ffc.svg";
import mainIcon from "assets/svg/ffcorp_main.svg";
import TickerIcon from "assets/svg/TickerLogo4.svg";
import { useNavigate } from 'react-router-dom';

const drawerWidth = 240;
const navItems = ['Request A Demo', 'Login'];

function DrawerAppBar(props) {
    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const navigate = useNavigate()
    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };
    const handleClick = (value) => {
        if (value == "Login") {
            localStorage?.clear()
            navigate("/login")
        }
    }
    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <Typography variant="h6" sx={{ my: 2 }}>
                <img
                    style={{
                        height: "90px",
                        width: "180px"
                    }}
                    src={TickerIcon}
                    alt="Tickr app icon"
                // className={
                //     sidebarOpen ? styles.mainIconImage : styles.mainZenputIcon
                // }
                />
            </Typography>
            <Divider />
            {/* <List>
                {navItems.map((item) => (
                    <ListItem key={item} disablePadding>
                        <ListItemButton sx={{ textAlign: 'center' }} onClick={() => handleClick(item)}>
                            <ListItemText primary={item} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List> */}
        </Box>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box sx={{ display: 'flex'  , marginBottom: "80px" }}>
            <CssBaseline />
            <AppBar component="nav">
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{ margin:"auto" ,  display: { xs: 'none', sm: 'block' } }}
                    >
                        <img
                            style={{
                                marginTop:"0.5rem",
                                height: "55px",
                                width: "195px",
                            }}
                            src={TickerIcon}
                            alt="Tickr app icon "
                        // className={
                        //     sidebarOpen ? styles.mainIconImage : styles.mainZenputIcon
                        // }
                        />
                    </Typography>
                    {/* <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                        {navItems.map((item) => (
                            <Button key={item} sx={{ color: '#fff' }} onClick={() => handleClick(item)}>
                                {item}
                            </Button>
                        ))}
                    </Box> */}
                </Toolbar>
            </AppBar>
            <nav>
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                    {drawer}
                </Drawer>
            </nav>
            {/* <Box component="main" sx={{ p: 3 }}>
                <Toolbar />

            </Box> */}
        </Box>
    );
}

DrawerAppBar.propTypes = {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};

export default DrawerAppBar;
